import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import GoodsHeader from "../../components/PagesHeaders/GoodsHeader/GoodsHeader";
import GoodsForm from "../../components/GoodsForm/GoodsForm";
import GoodsList from "../../components/GoodsList/GoodsList";
import GroupsList from "../../components/GroupsList/GroupsList";
import GroupForm from "../../components/GroupForm/GroupForm";
import { getGoodsSagaAction, getGroupsSagaAction } from "../../redux/sagaActions";
import GoodsStore from "../../components/GoodsStore/GoodsStore";

const Goods = () => {
    const dispatch = useDispatch();
    const currentEstablishment = useSelector(state => state.currentEstablishment);

    const [page, setPage] = useState(true);
    const [groups_page, setGroupsPage] = useState(false);

    // Получение списка товаров
    useEffect(() => {
        if (!currentEstablishment) return;

        // Получаем список групп товаров
        dispatch(getGroupsSagaAction());

        // Получаем список товаров
        dispatch(getGoodsSagaAction());
    }, [currentEstablishment]);

    return (
        <>
            <Header component={
                <GoodsHeader
                    page={ page }
                    setPage={ setPage }
                    groups_page={ groups_page }
                    setGroupsPage={ setGroupsPage }
                />
            } />
            <GoodsForm/>
            <GroupForm/>
            <div className="page">
                { page && <GoodsStore/> }
                { !page && !groups_page && <GoodsList/> }
                { !page && groups_page && <GroupsList/> }
            </div>
        </>
    );
};

export default Goods;